/* eslint-disable */
import { Component } from "react";
import { Col, Container, Row, Button } from "reactstrap";
import Select from "react-select";
import { _, Utils, Trans, Images } from "Helpers";
import { AllLeague, Banner, CreateJoinButton, MobHeader, MultiBanner } from "Components";
import { ReduxHOC } from "HOC";
import Moment from "react-moment";
import CountDownCustom from "../../Views/CountDownCustom";


class League extends Component {
  constructor(props) {
    super(props);
    this.nodes = {};
    const { t } = props;
    this.state = {
      is_single_player: Utils.isSinglePlayer(),
      league: null,
      isFrom: this.props.location && this.props.location.state ?  this.props.location.state.isFrom : '',
      LeagueType: [
        { value: "all_league", label: t("All Leagues") },
        { value: "global_league", label: t("Global Leagues") },
        { value: "other_league", label: t("Private Leagues") },
      ],
      hideLEeague: false,
      contestData : JSON.parse(localStorage.getItem('contestData')) || {}
    };
  }
  setNodeRef(provider, node) {
    if (node) {
      this.nodes[provider] = node;
    }
  }
  handleChange = (e, type) => {
    const name = !type ? e.target.name : type;
    let value = !type ? e.target.value : e;
    this.setState({ [name]: value });
    if (e.label === "Private Leagues") {
      this.setState({ hideLEeague: true })
    }
    else {
      this.setState({ hideLEeague: false })
    }
  };

  componentDidMount() {
    this.setState({
      league: this.state.LeagueType[0],
    });
  }

  GetAllLeague = () => {
    this.nodes.AllLeague.GetAllLeague();
  };

  callbackListUpdate =()=>{
    this.GetAllLeague()
  }

  checkDate = (inputDate) => {
    const now = new Date() && new Date();
		const enteredDate = new Date(inputDate);
		const differenceInHours = Math.abs(enteredDate - now) / (1000 * 60 * 60);
		const isSameDay = now.toDateString() === enteredDate.toDateString();
		const isWithin24Hours = differenceInHours <= 24;
        if (isSameDay) {
			return "Today";
		} else if (enteredDate > now) {
			if (isWithin24Hours) {
				return "Tomorrow";
			} else {
				return "Future Date";
			}
		} else {
			if (isWithin24Hours) {
				return "Yesterday";
			} else {
				return "Past Date";
			}
		}
};

 goBack =()=>{
    //  if(this.state.isFrom=='complete'){
    //  this.props.history.goBack();
    //  }else{
     this.props.history.push('/')
    //  }
  }

  render() {
    const { t } = this.props;
    const { league, LeagueType, contestData } = this.state;

    const SelectProps = {
      isSearchable: false,
      className: "react-select",
      classNamePrefix: "react-select",
    };

    let MobHeaderProps = {
      // titleContest: contestData,
      backTitleAction: "",
      drawerMenu: true,
      backHandle: true,
      centerTitle: 'Leagues',
      backTo: '/'
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'center' }} className="p-t-wrap">
        {/* <div className="hide-on-sm" style={{ paddingTop: '100px', paddingRight: '50px' }}>
          <Banner type="9" paddingTop paddingBottom />
        </div> */}
        <MobHeader {...MobHeaderProps}/>
        <div>
          {/* <Container className="small-container">
            <Row className="gutters-5px margin-top-default mb-5p">
              <Col>
                <CreateJoinButton callback={this.GetAllLeague} />
              </Col>
              <Col>
                <Select
                  {...SelectProps}
                  placeholder={t("Select Captain")}
                  value={league}
                  options={LeagueType}
                  onChange={(e) => this.handleChange(e, "league")}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <AllLeague
                  extend
                  className="league-page bg-fixclr"
                  selected={league}
                  getInstance={this.setNodeRef.bind(this, "AllLeague")}
                />
              </Col>
            </Row>
          </Container> */}
        </div>
        <Container className="container-up cont-spc-mob">
                  {/* <div className="heading-main leagues only-mob">Leagues</div> */}

        <div className='title-for-dashboard view-link-mob league'>
          <div className='contest-info-myteam gray'>
            <div className='contest-info-head'>
              <span className='curved-btn' onClick={() => this.goBack()}>
                  <span><i className="icon-previous"/></span>
              </span>
              <h6>{contestData.contest_name}</h6>
            </div>
              <div className='contest-info-subhead'>
                <h5>{contestData.league_name}</h5>
                <span className='gameweek-lbl'>{Utils.getWeekLabel(Utils.getMultiLeg().week_abbr[contestData.start_week])} {contestData.start_week} - {contestData.end_week}</span>
                <span className='seprate'>|</span>
                <div className="schedule-date">
                    {this.checkDate(contestData.deadline_date) === "Today" && !Utils.hasDateTimePassed(Utils.getUtcToLocal(contestData.deadline_date))? (
                        <div className="count-clock">
                            <CountDownCustom
                                targetDate={Utils.getUtcToLocal(contestData.deadline_date)}
                            />
                        </div>
                    ) :
                    contestData.status == "3" ? <div className='completed'>Completed</div> :
                    (this.checkDate(contestData.deadline_date) === "Yesterday" || this.checkDate(contestData.deadline_date) === "Past Date") || Utils.hasDateTimePassed(Utils.getUtcToLocal(contestData.deadline_date))? 
                          <div className='contest-live'>Live <img src={Images.LIVE_RED_ARROW} alt="next-live"/></div>
                      :
                      (
                        <div className="schedule-date">
                            <Moment
                                date={Utils.getUtcToLocal(contestData.deadline_date)}
                                format="DD MMM - hh:mm A"
                            />
                        </div>
                    )}
                </div>
              </div>
          </div>
          <div className="heading-leagues ">
            <Select
              {...SelectProps}
              placeholder={t("Select Captain")}
              value={league}
              options={LeagueType}
              onChange={(e) => this.handleChange(e, "league")}

            />
          </div>
        </div>
          
          <div className="multi-banner-wrap multibanner-wrap league ">
            {/* <Banner type='54'  bannerLobby={true}/> */}
            <MultiBanner type='30'  bannerLobby={true}/>
          </div>
          <Row className="row-leagues p-fix-leagues">
            <Col md={6} className="left-wrap">
              <div className="heading-block">
                <span className="title-id"><Trans>Joined Leagues</Trans></span>
                <span id="prix">
                  <img src={Images.TROPHY_IC} alt='trophy ic' id='trophy' /><Trans>In the winning zone</Trans></span>
              </div>
              <AllLeague
                extend
                className="league-page bg-fixclr"
                selected={league}
                hideLEeague={this.state.hideLEeague}
                getInstance={this.setNodeRef.bind(this, "AllLeague")}
              /></Col>
            <Col md={6} className="right-wrap">
              {/* <CreateJoinButton */}
              <CreateJoinButton is_banner {...this.props} league={true} callback={this.callbackListUpdate}/>
              <div style={{ height: '15px' }}></div>
              <Banner type="10" bannerLobby={true}/>
            </Col>
          </Row>

        </Container>
        <div className="hide-on-sm">
          {/* <Banner type="10" paddingTop /> */}
        </div>
      </div>
    );
  }
}

export default ReduxHOC(League);
